/**
 * Shared domain enumerations — part of the client↔server contract (src/shared,
 * HS2-HAQYG6). Plain runtime values (no deps), safe for both the server and the
 * client bundle. Previously duplicated in src/backend/decisions/service.ts and
 * src/client/state.ts.
 */

/** Decision actions a reviewer can record on a line. */
export const DECISION_ACTIONS = ['approve', 'negotiate', 'reject', 'defer', 'import', 're-quote'] as const;
export type DecisionAction = (typeof DECISION_ACTIONS)[number];

/** How a quoted price is delivered (the comparison basis). */
export const PRICE_BASES = ['ex-works', 'delivered-to-site', 'fob', 'cif', 'unknown'] as const;
export type PriceBasis = (typeof PRICE_BASES)[number];

/** Common reasons a reviewer may pick a non-best (not lowest-priced) quote
 *  (HS2-EKEE9S). "Other" reveals a free-text field; the stored reason is the
 *  chosen label or that free text. */
export const SELECTION_REASONS = [
  'Better delivery reliability',
  'Faster lead time',
  'Better payment terms',
  'Better quality or brand',
  'Existing relationship',
  'Availability / in stock',
  'Other',
] as const;
export type SelectionReason = (typeof SELECTION_REASONS)[number];

/** Vendor kinds the UI offers (FR-3.9); stored as free text, so older values still read back (HS2-BBZXKM). */
export const VENDOR_TYPES = ['wholesaler', 'trader', 'importer', 'manufacturer', 'distributor', 'foreign'] as const;
export type VendorType = (typeof VENDOR_TYPES)[number];
